var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUbrClean(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ui ui-ubr_delete",
    viewBox: "0 0 80 80",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.03 12h-36.3L4.93 40l25.8 28h36.3c5.5 0 9.9-4.5 9.9-10V22c0-5.5-4.4-10-9.9-10zm5.9 46c0 3.3-2.7 6-5.9 6h-34.6l-22.1-24 22.1-24h34.6c3.3 0 5.9 2.7 5.9 6v36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.43 27.9l-9.1 9.3-9.2-9.3-2.8 2.8 9.2 9.3-9.2 9.3 2.8 2.8 9.2-9.3 9.1 9.3 2.8-2.8-9.1-9.3 9.1-9.3-2.8-2.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrClean);
export default __webpack_public_path__ + "static/media/ubr_clean.9d387f00e4f8e8a5095a1d15806c572b.svg";
export { ForwardRef as ReactComponent };